/* eslint-disable import/prefer-default-export */
/** LaunchDarkly flag key for the Recommendation Service V2 migration. */
export const RECOMMENDATIONS_V2 = 'releaseBeRecommendationsV2';
